import React, { useEffect, useState } from 'react';
import { Container, Header, InviteButton, TitleContainer, TooltipContainer } from './ReferralsList.styles';
import { Text24Bold } from '../utils/Text/Text.styles';
import { ReactComponent as InfoIcon } from '../../assets/icons/info.svg';
import ReferralInfo from '../ReferralInfo/ReferralInfo';
import { notifyError, notifyInfo } from '../../utils/notify';
import { useDispatch, useSelector } from 'react-redux';
import { selectUser, selectUserActionsPending } from '../../store/slices/user/slice';
import { fetchReferrals } from '../../store/slices/user/asyncThunks';

import ReferralsEarningsByMonth from '../ReferralsEarningsByMonth/ReferralsEarningsByMonth';

const ReferralsList = () => {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const [referrals, setReferrals] = useState(null);
  const { fetchReferrals: fetchReferralsPending } = useSelector(selectUserActionsPending);

  const [showTooltip, setShowTooltip] = useState(false);

  const copyInviteText = () => {
    const text = `Access TLINK with my invite code: ${user.referralInfo.code}\nhttps://creators.tlink.me/sign-up?invite=${user.referralInfo.code}`;
    navigator.clipboard.writeText(text);
    notifyInfo('Text copied!');
  };

  useEffect(() => {
    dispatch(fetchReferrals())
      .unwrap()
      .then(payload => {
        setReferrals(payload.referrals);
      })
      .catch(err => {
        notifyError(err.message);
      });
  }, [dispatch]);

  return (
    <Container>
      <Header>
        <TitleContainer>
          <Text24Bold>Referrals</Text24Bold>
          <InfoIcon onMouseEnter={() => setShowTooltip(true)} onMouseLeave={() => setShowTooltip(false)} />
          {showTooltip && (
            <TooltipContainer>
              <ReferralInfo />
            </TooltipContainer>
          )}
        </TitleContainer>
        <InviteButton title="Invite Friend" onClick={copyInviteText} />
      </Header>
      <ReferralsEarningsByMonth pending={fetchReferralsPending} earningsData={referrals} />
    </Container>
  );
};

export default ReferralsList;
